if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.split(search).join(replacement);
  };
}

Window.prototype.queryParam = function (name) {
    const url = this.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};